import axios from "axios";
import {
  toast
} from "react-toastify";
import {
  push
} from "connected-react-router";
export const SUB_GET_ARTICLES_REQUEST = "SUB_GET_ARTICLES_REQUEST";
export const SUB_GET_ARTICLES_SUCCESS = "SUB_GET_ARTICLES_SUCCESS";
export const SUB_GET_ARTICLES_FAIL = "SUB_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: SUB_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "dashboard/subscriptions",
      params: params,
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: SUB_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: SUB_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const SUB_CREATE_ARTICLE_REQUEST = "SUB_CREATE_ARTICLE_REQUEST";
export const SUB_CREATE_ARTICLE_SUCCESS = "SUB_CREATE_ARTICLE_SUCCESS";
export const SUB_CREATE_ARTICLE_FAIL = "SUB_CREATE_ARTICLE_FAIL";
export const subArticle = ({
  type = "is_push_selected",
  mark,
  post_category_join_ids
}) => dispatch => {
  dispatch({
    type: SUB_CREATE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/posts/mark",
      params: {
        type,
        mark,
        post_category_join_ids
      },
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: SUB_CREATE_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        if (type === "is_push_selected") {
          dispatch(push("subscriptions"));
        } else {
          dispatch(push("articles"));
        }
      } else {
        dispatch({
          type: SUB_CREATE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const SUB_SAT_ARTICLE_REQUEST = "SUB_SAT_ARTICLE_REQUEST";
export const SUB_SAT_ARTICLE_SUCCESS = "SUB_SAT_ARTICLE_SUCCESS";
export const SUB_SAT_ARTICLE_FAIL = "SUB_SAT_ARTICLE_FAIL";
export const satArticle = () => dispatch => {
  dispatch({
    type: SUB_SAT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/subscriptions/data",
      params: {},
      method: "GET",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: SUB_SAT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: SUB_SAT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const SUB_PUSH_ARTICLE_REQUEST = "SUB_PUSH_ARTICLE_REQUEST";
export const SUB_PUSH_ARTICLE_SUCCESS = "SUB_PUSH_ARTICLE_SUCCESS";
export const SUB_PUSH_ARTICLE_FAIL = "SUB_PUSH_ARTICLE_FAIL";
export const pushArticle = () => dispatch => {
  dispatch({
    type: SUB_PUSH_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/subscriptions/push",
      params: {},
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: SUB_PUSH_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: SUB_PUSH_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const SUB_REMOVE_ARTICLE_REQUEST = "SUB_REMOVE_ARTICLE_REQUEST";
export const SUB_REMOVE_ARTICLE_SUCCESS = "SUB_REMOVE_ARTICLE_SUCCESS";
export const SUB_REMOVE_ARTICLE_FAIL = "SUB_REMOVE_ARTICLE_FAIL";
export const removeArticle = post_category_join_id => dispatch => {
  dispatch({
    type: SUB_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/subscription/remove",
      data: {
        post_category_join_id
      },
      method: "post"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: SUB_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        dispatch(push("/dash/admin/subscriptions"));
      } else {
        dispatch({
          type: SUB_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};